import { proxy } from 'valtio'

export const uiState = proxy({
  music: {
    source: '../startImages/music/bgm.mp3',
    isMusicPlaying: false
  },
  intro: {
    visible: true,
    pcContent: {
      zh: `建議連接耳機
以獲得最佳的觀展體驗`,
      en: `It is recommended to connect headphones
for the best exhibition experience.`
    },
    phContent: {
      zh: `建議連接耳機
以獲得最佳的觀展體驗`,
      en: `It is recommended
to connect headphones
for the best exhibition experience.`
    }
  },
  homepage: {
    visible: false,
    touchStartY: null,
    touchCurrentY: null,
    scrollCount: 0,
    prevScrollY: 0,
    isScrolling: false,
    canScroll: false,
    canTouch: false,
    logoDuration: false,
    showTip: false,
    showTipAnimation: false,
    isEnterHover: false,
    showEndTipAnimation: false,
    timer: 0,
    showScrollText: true,
    prevScrollCount: 0,
    zh: {
      title: `「當我們望春風，
    　我們想望的是...」`,
      content: `當我們望春風，所盼的、所望的，究竟是什麼呢……

這是一首歌的故事，更是近代臺灣的一部文化史。〈望春風〉這首歌，自創作發表以來，陪伴臺灣人足足90年了，受到三個世代、不同族群的演繹與熱愛，幾乎知名的歌手、歌王歌后都有演唱，版本不計其數，從留聲機、電唱機、收音機、錄音機，播到卡拉OK、CD Player、ipod、手機，發展成歌中劇唱片、戲劇、電影、小說、連續劇、文化節目、雜誌、出版社，是迴盪在空中飄遠的集合哨聲，更是臺灣游子們沉在心底的鄉愁……

這麼多的〈望春風〉齊聚一堂，在你面前展開的，是一條臺灣流行音樂的長河，也會讓你聽到，這島嶼上來來去去的人們，對現在與未來，曾經有過怎麼樣的慾念和想像。`
    }
  },
  detailPage: { visible: false },
  mouseStyle: {
    style: 'default',
    positionX: 0,
    positionY: 0,
    isMouseInside: true,
    isMapHover: false,
    showOrangeSpot: true
  },
  iconState: 0,
  teamEventText: '',
  shouldUpdateTeamVolume: false,
  miniMap: {
    visible: false,
    fovX: 128.2,
    fovY: 814,
    dotWidth: 7,
    krpano: { scene: 'pano127', hLookAt: '0', fov: '90', vLookAt: '0' }
  }
})

window.frontEnd = {
  ...window.frontEnd,
  uiState
}
